import { render, staticRenderFns } from "./DuplicateArchiver.vue?vue&type=template&id=e027bc48&scoped=true&"
import script from "./DuplicateArchiver.vue?vue&type=script&lang=js&"
export * from "./DuplicateArchiver.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateArchiver.vue?vue&type=style&index=0&id=e027bc48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e027bc48",
  null
  
)

export default component.exports